import { createSlice } from '@reduxjs/toolkit';

export interface TrackFormatInfo {
  key:				string;
  description:		string;
}

export interface TrackFormatsHolder {
  is_new?:			boolean;
  to_delete?:		boolean;
  track_formats:	TrackFormatInfo[];
}

export const trackFormatsUrl = "/track_formats.json";

const initialState: TrackFormatsHolder = {
  track_formats:	[],
};

export const trackFormatsSlice = createSlice({
  name: 'trackFormats',
  initialState,
  reducers: {
    assign: (state, action) => {
      state.track_formats = action.payload.track_formats;
    },
    setTrackFormats: (state, action) => {
      state.track_formats = action.payload;
    },
  },
});

export function copyTrackFormatInfo(tf: TrackFormatInfo): TrackFormatInfo {
  return {
    key:				tf.key,
    description:		tf.description,
  };
}

export function copyTrackFormatInfos(tfs: TrackFormatInfo[]): TrackFormatInfo[] {
  if (!tfs)
    return [];

  return tfs.map((tf: TrackFormatInfo) => copyTrackFormatInfo(tf));
}

export function copyTrackFormatsHolder(holder: TrackFormatsHolder): TrackFormatsHolder {
  return {
    track_formats:		copyTrackFormatInfos(holder.track_formats),
  };
}

export function getNewTrackFormatInfo(): TrackFormatInfo {
  return {
    key:				"",
    description:		"",
  };
}
